import { HtmlMarkup, Typography } from '@/core/ui';
import type { IPageInfo } from '@/types';

type Props = { data: IPageInfo };

export const Slide2 = ({ data }: Props) => {
  const { title, description, image_one, image_three, image_two } = data;

  return (
    <div className="bg-content1 flex flex-row">
      <div className="flex space-x-8 basis-1/2">
        <div className="w-[499px] h-[1080px]">
          {image_one.path ? (
            <img
              alt={image_one.caption || ''}
              src={image_one.path}
              className="w-full h-full object-cover"
            />
          ) : null}
        </div>
        <div className="flex flex-col space-y-20 max-w-[283px] mt-40">
          <div className="flex items-center">
            <div className="h-[8.5px] w-[41px] bg-olive" />
            <div className="h-[8.5px] w-[41px] bg-danger" />
          </div>
          <div className="flex flex-col space-y-8">
            <Typography className="text-chalk font-semibold text-[26px] leading-[29.9px] tracking-[1.3px]">
              {title}
            </Typography>
            <HtmlMarkup className="text-chalk font-light text-[26px] leading-[29.9px] tracking-[1.3px]">
              {description}
            </HtmlMarkup>
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-between basis-1/2">
        <div className="flex space-x-6">
          {image_two.path ? (
            <div className="w-[480px] h-[480px]">
              <img
                alt={image_two.caption || ''}
                src={image_two.path}
                className="w-full h-full object-cover"
              />
            </div>
          ) : null}
          <div className="flex items-end max-w-[283px]">
            <HtmlMarkup className="text-chalk font-light text-[26px] leading-[29.9px] tracking-[1.3px]">
              {image_two.caption}
            </HtmlMarkup>
          </div>
        </div>
        {image_three.path ? (
          <div className="w-[894px] h-[511px]">
            <img
              alt={image_three.caption || ''}
              src={image_three.path}
              className="w-full h-full object-cover"
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};
